import { createEnumMap } from 'Commons/helpers/utils/Formatter';
import { formatter } from 'External/containers/createoccupancy/config/PermissionKeys';

const MOVE_OUT_PERMISSION_KEYS = createEnumMap(['moveOutDate', 'overrideResolveCharges',
    'waiveNotificationPenalty'], formatter);

export default MOVE_OUT_PERMISSION_KEYS;
